import { SearchField } from '@rematter/ui-web';

import * as state from '../../_state/brokeredOrdersList.state';
import { useTranslations } from '../../i18n/useTranslations';

import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

export const BrokeredOrderFilters = () => {
  const t = useTranslations();

  const [searchTerm, setSearchTerm] = useDebouncedAtom(state.$searchTerm, 300);

  return (
    <SearchField
      value={searchTerm ?? ''}
      onChange={setSearchTerm}
      placeholder={t.orders.list.search}
      aria-label={t.orders.list.ariaLabel}
      className="@BrokeredOrderFilters w-64"
      autoFocus
    />
  );
};
